module.exports = __webpack_public_path__ + "static/fonts/CoTextCorp-Bold.0b33c12.woff2";